export default {
  'button-text': {
    label: 'Button text',
    type: 'text'
  },
  'button-link': {
    label: 'Button link',
    type: 'text',
    hideOnList: true
  },
  'button-style': {
    label: 'Button style',
    type: 'radio',
    options: [
      { value: 'default', text: 'Default' },
      { value: 'outlined', text: 'Outlined' },
      { value: 'text', text: 'Plain text' }
    ],

    hideOnList: true
  },
  'button-background-color': {
    label: 'Button background color',
    type: 'background-color',
    default: 'var(--primary-color)',
    hideOnList: true
  },
  'button-text-color': {
    label: 'Button text color',
    type: 'text-color',
    hideOnList: true
  }
}
